module.exports = __webpack_public_path__ + "img/background.a9a73b41.png";